import { DocumentDownloadOptions } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface ExportWithDocumentsResponse {
  exportId?: string;
  jobId?: string;
  inProgress?: boolean;
}

export const useExportKimWithDocuments = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  const startExport = async (
    exportId: string,
    title: string,
    messageId: string,
    artifactId?: string,
    artifactVersionNumber?: number,
    options?: DocumentDownloadOptions,
  ): Promise<ExportWithDocumentsResponse> => {
    if (!matterId || !subsetId || !threadId) {
      throw new Error('Missing required IDs');
    }

    const endpoint = `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/export-with-documents`;
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        exportId,
        title,
        messageId,
        ...(artifactId && { artifactId }),
        ...(artifactVersionNumber !== undefined && { artifactVersionNumber }),
        ...(options && { options }),
      },
    });

    const response = await fetch(endpoint, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to start Kim export');
    }

    return response.json();
  };

  const getProgressEndpoint = () => {
    return `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/export/progress`;
  };

  return {
    startExport,
    getProgressEndpoint,
  };
};
